import { configureStore } from '@reduxjs/toolkit';
import locationsReducer from './locationsSlice';
import usersReducer from './usersSlice';
import keyTypesReducer from './keyTypesSlice';
import keyInventoryReducer from './keyInventorySlice';
import peopleReducer from './peopleSlice';
import assignmentsReducer from './assignmentsSlice';
import keyRequestsReducer from './keyRequestsSlice';

export const store = configureStore({
  reducer: {
    locations: locationsReducer,
    users: usersReducer,
    keyTypes: keyTypesReducer,
    keyInventory: keyInventoryReducer,
    people: peopleReducer,
    assignments: assignmentsReducer,
    keyRequests: keyRequestsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
